import { ContextType } from "../../../../../../data/enums/ContextType";
import "./EditorTopNavigationBar.scss";
import React, { useState } from "react";
import classNames from "classnames";
import { AppState } from "../../../../../../store";
import { connect } from "react-redux";
import {
  toggleAiAssistButtons,
  toggleAiAssistForm,
  updateAiAssistMode,
  updateAiAssistStatus,
  updateAiModeStatus,
  updateCrossHairVisibleStatus,
  updateImageDragModeStatus,
} from "../../../../../../store/general/actionCreators";
import { GeneralSelector } from "../../../../../../store/selectors/GeneralSelector";
import { ViewPointSettings } from "../../../../../../settings/ViewPointSettings";
import { ImageButton } from "../../../../../Common/ImageButton/ImageButton";
import { ImageData } from "../../../../../../store/labels/types";
import { ViewPortActions } from "../../../../../../logic/actions/ViewPortActions";
import { LabelsSelector } from "../../../../../../store/selectors/LabelsSelector";
import { LabelType } from "../../../../../../data/enums/LabelType";
import { AISelector } from "../../../../../../store/selectors/AISelector";
import { ISize } from "../../../../../../interfaces/ISize";

import withStyles from "@material-ui/core/styles/withStyles";
import { Badge, Tooltip } from "@material-ui/core";
import Fade from "@material-ui/core/Fade";
import FlagLabelsLists from "../SideNavigationBar/TagLabelsList/flagLabelsList";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Input,
  Label,
  Button,
} from "reactstrap";
import { isPropertySignature } from "typescript";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPalette } from "@fortawesome/free-solid-svg-icons";
import {
  updateActiveLabelId,
  setImageUndoIndex,
  updateImageDataById,
  updateImageDataByIdwithoutundo,
} from "../../../../../../store/labels/actionCreators";
import { store } from "../../../../../..";
import ImageComments from "./ImageComments";
import { getCokkie } from "../../../../../login/Login";
import { CanvasUtil } from "../../../../../../utils/CanvasUtil";
import { EditorModel } from "../../../../../../staticModels/EditorModel";
import { EditorActions } from "../../../../../../logic/actions/EditorActions";
import { PolygonRenderEngine } from "../../../../../../logic/render/PolygonRenderEngine";
import { LineRenderEngine } from "../../../../../../logic/render/LineRenderEngine";
import { PolylineRenderEngine } from "../../../../../../logic/render/PolylineRenderEngine";
import AiModals from "../../../../../../components/ai-assist/AiModals";
interface IProps { }

// interface IState {
//     size: ISize;
// }
// const [imagecount, setImagecount] = useState([]);
// class imagesData extends React.Component<IProps, IState> {
//     setImagecount(imagesData.length)
// }
const BUTTON_SIZE: ISize = { width: 36, height: 37 };
const BTN_SIZE: ISize = { width: 34, height: 35 };
const BUTTON_PADDING: number = 10;


export const StyledTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "#171717",
    color: "#ffffff",
    boxShadow: theme.shadows[1],
    fontSize: 12,
    maxWidth: 200,
    textAlign: "center",
    zIndex:9999,
  },
}))(Tooltip);

const getButtonWithTooltip = (
  key: string,
  tooltipMessage: string,
  imageSrc: string,
  imageAlt: string,
  isActive: boolean,
  href?: string,
  onClick?: () => any
): React.ReactElement => {
  return (
    <StyledTooltip
      key={key}
      disableFocusListener={true}
      title={tooltipMessage}
      TransitionComponent={Fade}
      TransitionProps={{ timeout: 600 }}
      placement="bottom"
    >
      <div>
        <ImageButton
          buttonSize={BUTTON_SIZE}
          padding={BUTTON_PADDING}
          image={imageSrc}
          imageAlt={imageAlt}
          href={href}
          onClick={onClick}
          isActive={isActive}
        />
      </div>
    </StyledTooltip>
  );
};

const getBtnWithTooltip = (
  key: string,
  tooltipMessage: string,
  imageSrc: string,
  imageAlt: string,
  isActive: boolean,
  href?: string,
  onClick?: () => any
): React.ReactElement => {
  return (
    <StyledTooltip
      key={key}
      disableFocusListener={true}
      title={tooltipMessage}
      TransitionComponent={Fade}
      TransitionProps={{ timeout: 600 }}
      placement="bottom"
    >
      <div>
        <ImageButton
          buttonSize={BTN_SIZE}
          padding={BUTTON_PADDING}
          image={imageSrc}
          imageAlt={imageAlt}
          href={href}
          onClick={onClick}
          isActive={isActive}
        />
      </div>
    </StyledTooltip>
  );
};

// export const undo = () => {

//   var number = JSON.parse(localStorage.getItem(`undoindex_${LabelsSelector.getActiveImageData().image_id}`));
//   if (JSON.parse(localStorage.getItem(`undoRedo_${LabelsSelector.getActiveImageData().image_id}`)).length > number + 1) {
//     localStorage.setItem(`undoindex_${LabelsSelector.getActiveImageData().image_id}`, JSON.stringify(number + 1))
//     store.dispatch(undoRedo(LabelsSelector.getActiveImageData().image_id, JSON.parse(localStorage.getItem(`undoRedo_${LabelsSelector.getActiveImageData().image_id}`))[number + 1]))
//   }
// };


const isPolygonPointUndoActive = (): boolean => {
  const engine = EditorModel.supportRenderingEngine;
  if (!engine || engine.labelType !== LabelType.POLYGON) {
    return false;
  }

  const points = localStorage.getItem("mousePositionPoints");
  if (!points) {
    return false;
  }

  try {
    const parsed = JSON.parse(points);
    return Array.isArray(parsed) && parsed.length > 0;
  } catch {
    return false;
  }
};

const getUndoRedoState = (imageId: string) => {
  const labelsState = store.getState().labels;
  const stack = labelsState.undoRedoByImage?.[imageId] || [];
  const undoIndex = labelsState.undoIndexByImage?.[imageId] || 0;
  return { stack, undoIndex };
};

export const undo = () => {
  if (isPolygonPointUndoActive()) {
    (EditorModel.supportRenderingEngine as PolygonRenderEngine).undo();
    EditorActions.fullRender();
    return;
  }

  const imageData = LabelsSelector.getActiveImageData();
  if (!imageData) return;

  const { stack, undoIndex } = getUndoRedoState(imageData.image_id);
  if (stack.length > undoIndex + 1) {
    const nextIndex = undoIndex + 1;
    store.dispatch(setImageUndoIndex(imageData.image_id, nextIndex));
    store.dispatch(
      updateImageDataByIdwithoutundo(imageData.image_id, stack[nextIndex])
    );
  }

  EditorActions.fullRender();
};

export const redo = () => {
  if (isPolygonPointUndoActive()) {
    (EditorModel.supportRenderingEngine as PolygonRenderEngine).redo();
    EditorActions.fullRender();
    return;
  }

  const imageData = LabelsSelector.getActiveImageData();
  if (!imageData) return;

  const { stack, undoIndex } = getUndoRedoState(imageData.image_id);
  if (undoIndex > 0 && stack[undoIndex - 1]) {
    const nextIndex = undoIndex - 1;
    store.dispatch(setImageUndoIndex(imageData.image_id, nextIndex));
    store.dispatch(
      updateImageDataByIdwithoutundo(imageData.image_id, stack[nextIndex])
    );
  }

  EditorActions.fullRender();
};
interface IProps {
  activeContext: ContextType;
  updateImageDragModeStatusAction: (imageDragMode: boolean) => any;
  updateAiModeStatusAction: (aiMode: boolean) => any;
  updateCrossHairVisibleStatusAction: (crossHairVisible: boolean) => any;
  imageDragMode: boolean;
  aiMode: boolean;
  crossHairVisible: boolean;
  activeLabelType: LabelType;
  activeImageIndex: number;
  imagesData: ImageData[];
  updateAiAssistModeAction: (mode: 'rects' | 'points' | '' | null) => void;
  updateAiAssistStatusAction: (status: 'running' | 'pending' | 'failed' | null) => void;
  toggleAiAssistFormAction: (openForm: boolean) => void;
  toggleAiAssistButtonsAction: (showButtons: boolean) => void;
  aiAssist: {
    mode: 'rects' | 'points' | '' | null;
    status: 'running' | 'pending' | 'failed' | null;
    openForm: boolean;
    showButtons: boolean;
    models: any[];
  };

}

const EditorTopNavigationBar: React.FC<IProps> = ({
  activeContext,
  updateImageDragModeStatusAction,
  updateAiModeStatusAction,
  updateCrossHairVisibleStatusAction,
  imageDragMode,
  crossHairVisible,
  activeLabelType,
  activeImageIndex,
  imagesData,
  aiMode,
  updateAiAssistModeAction,
  updateAiAssistStatusAction,
  toggleAiAssistFormAction,
  toggleAiAssistButtonsAction,
  aiAssist,
}) => {
  const FlagLabeledImages = imagesData.reduce(
    (currentCount: number, currentImage: ImageData) => {
      return currentCount + (currentImage.flags.length !== 0 ? 1 : 0);
    },
    0
  );
  // var aimode=false
  const LabeledImages = imagesData.reduce(
    (currentCount: number, currentImage: ImageData) => {
      return (
        currentCount +
        (currentImage.labelRects.length != 0 ||
          currentImage.labelPoints.length != 0 ||
          currentImage.flags.length != 0 ||
          currentImage.labelPolygons.length != 0 ||
          currentImage.labelPolylines.length != 0 ||
          currentImage.labelLines.length != 0||
          currentImage.labelTags.length !=0
          ? 1
          : 0)
      );
    },
    0
  );
  const getClassName = () => {
    return classNames("EditorTopNavigationBar grey-card5", {
      "with-context": activeContext === ContextType.EDITOR,
    });
  };

  const crossHairOnClick = () => {
    updateCrossHairVisibleStatusAction(!crossHairVisible);
  };

  
    const [showAi, setShowAi] = useState('')
    const [showButtons, setShowButtons] = useState(false)

    const imageDragOnClick = () => {
      toggleAiAssistFormAction(false);
      toggleAiAssistButtonsAction(false);
      updateAiAssistModeAction('');
      updateAiModeStatusAction(false);
      updateImageDragModeStatusAction(!imageDragMode);
    // localStorage.setItem("aipreditions", JSON.stringify(""))
    updateAiModeStatusAction(false)
    setShowButtons(false)
    localStorage.setItem('aiMode', JSON.stringify(''));
    setShowAi(null)
  };


  const buttonsSlide = (e) => {
    e.preventDefault();
    if (openAiForm) {
      setOpenAiForm(false)
    } else {
    updateAiModeStatusAction(true)
    updateImageDragModeStatusAction(true);
    localStorage.setItem('aiMode', JSON.stringify(''));
    if (JSON.parse(localStorage.getItem('aiMode')) === 'rects') {
      setShowAi('rects')
    } else {
      setShowAi('points')
      localStorage.setItem('aiMode', JSON.stringify('points'));
    }
    setShowButtons(!showButtons);



    (
      EditorModel.supportRenderingEngine as PolygonRenderEngine
    ).cancelLabelCreation();
    (
      EditorModel.supportRenderingEngine as LineRenderEngine
    ).cancelLabelCreation();
    (
      EditorModel.supportRenderingEngine as PolylineRenderEngine
    ).cancelLabelCreation();
  }}


  const[openAiForm, setOpenAiForm] = useState(false)

  const handleWandRightClick = (e) => {
    e.preventDefault();
    updateImageDragModeStatusAction(true);
    updateCrossHairVisibleStatusAction(false);
  };


  const handleaipridictionRects = (e) => {
    e.preventDefault();
    const isAlreadySelected = aiAssist?.mode === "rects" || showAi === "rects";

    if (isAlreadySelected) {
      updateAiModeStatusAction(false);
      updateAiAssistModeAction("");
      localStorage.setItem("aiMode", JSON.stringify(""));
      setShowAi(null);
      return;
    }

    updateAiModeStatusAction(true);
    updateImageDragModeStatusAction(true);
    updateAiAssistModeAction("rects");
    localStorage.setItem("aiMode", JSON.stringify("rects"));
    setShowAi("rects");
  }

  const aipridition = (e) => {
    // updateImageDragModeStatusAction(true);    
    // localStorage.setItem("aipreditions", JSON.stringify(true))
    // updateImageDragModeStatusAction(true);
    // updateAiModeStatusAction(!aiMode)
    // aimode=(!aimode)
    e.preventDefault();
    const isAlreadySelected = aiAssist?.mode === "points" || showAi === "points";

    if (isAlreadySelected) {
      updateAiModeStatusAction(false);
      updateAiAssistModeAction("");
      localStorage.setItem("aiMode", JSON.stringify(""));
      setShowAi(null);
      return;
    }

    updateAiModeStatusAction(true);
    updateImageDragModeStatusAction(true);
    updateAiAssistModeAction("points");
    localStorage.setItem("aiMode", JSON.stringify("points"));
    setShowAi("points");
  };

  const getLabelTypeIcon = () => {
    switch (activeLabelType) {
      case LabelType.RECT:
        return "/ico/rectangle.png";
      case LabelType.POLYGON:
        return "/ico/polygon.png";
      case LabelType.POLYLINE:
        return "/ico/polyline.png";
        case LabelType.POINT : 
        return "/ico/point.png";
        case LabelType.TAG : 
        return "/ico/tags.png"
        case LabelType.LINE :
          return "/ico/line.png";
      default:
        return "/ico/default.png";
    }
    };
    
  const runningModel =
    aiAssist?.models?.find((model) => model.status === "running") || null;
  const hasRunningModel = !!runningModel;

  return (
    <div className={getClassName()}>
      <div className="ButtonWrapper border-bottom">
      {getButtonWithTooltip(
          "image-drag-mode",
          "draw mode",
          "/ico/pencil.png",
          "image-draw-mode",
          !imageDragMode,
          undefined,
          imageDragOnClick
        )}
        
        {getButtonWithTooltip(
          "cursor-cross-hair",
          crossHairVisible
            ? "turn-off cursor cross-hair"
            : "turn-on cursor cross-hair",
          "/ico/cross-hair.png",
          "cross-hair",
          crossHairVisible,
          undefined,
          crossHairOnClick
        )}
      </div>
          {hasRunningModel &&
          <>
      <div className="ButtonWrapper aiButtonWrapper border-bottom pb-2 pt-3">
      <div className={`aibuttons mb-2 d-flex flex-column py-2 px-1`} style={{ border: '0.1px dotted green' }}>
          <StyledTooltip title="Ai rect">
            <div className="Imagediv my-1 p-1 my-2"  onClick={handleaipridictionRects} style={{background:showAi === 'rects' ? ' #1a73e8' : ''}}>
          <img src="/ico/rectangle.png" style={{ filter:showAi === 'rects' ? 'brightness(0) invert(1)' : ''}} className="label-images aibuttonsshowing aibuttons"/>
          </div>
          </StyledTooltip>
          <StyledTooltip title="Ai point">
          <div className="Imagediv my-1 p-1" onClick={aipridition} style={{background:showAi === 'points' ? ' #1a73e8' : ''}}>
          <img src="/ico/point.png"style={{ filter:showAi === 'points' ? 'brightness(0) invert(1)' : '' }} className="label-images aibuttonsshowing aibuttons"/>
          </div>
          </StyledTooltip>

          
        </div>
      </div>
          </>
          }

      <div className="ButtonWrapper border-bottom pt-2">
        {getBtnWithTooltip(
          "undo",
          "undo",
          "/ico/undo.png",
          "undo",
          null,
          undefined,
          undo,
        )}
        {getBtnWithTooltip(
          "undo",
          "redo",
          "/ico/redo.png",
          "redo",
          null,
          undefined,
          redo,
        )}
      </div>

     
      <div className="ButtonWrapper">
        {/* {getButtonWithTooltip(
          "zoom-in",
          "zoom in",
          "/ico/zoom-in.png",
          "zoom-in",
          false,
          undefined,
          () => ViewPortActions.zoomIn()
        )}
        {getButtonWithTooltip(
          "zoom-out",
          "zoom out",
          "/ico/zoom-out.png",
          "zoom-out",
          false,
          undefined,
          () => ViewPortActions.zoomOut()
        )} */}
        {/* {getButtonWithTooltip(
          "zoom-fit",
          "fit image to available space",
          "/ico/zoom-fit.png",
          "zoom-fit",
          false,
          undefined,
          () => ViewPortActions.setDefaultZoom()
        )}
        {getButtonWithTooltip(
          "zoom-max",
          "maximum allowed image zoom",
          "/ico/zoom-max.png",
          "zoom-max",
          false,
          undefined,
          () => ViewPortActions.setOneForOneZoom()
        )} */}
      </div>
      {/* {(LabelsSelector.getActiveLabelType()=="POLYGON"||LabelsSelector.getActiveLabelType()=="RECT") &&
      <div className="ButtonWrapper">
    
        </div>
    } */}



        <div className="ButtonWrapper">
        {getButtonWithTooltip(
          "zoom-in",
          "zoom in",
          "/ico/zoom-in.png",
          "zoom-in",
          false,
          undefined,
          () => ViewPortActions.zoomIn()
        )}
        {getButtonWithTooltip(
          "zoom-out",
          "zoom out",
          "/ico/zoom-out.png",
          "zoom-out",
          false,
          undefined,
          () => ViewPortActions.zoomOut()
        )}
        {getButtonWithTooltip(
          "zoom-fit",
          "fit image to available space",
          "/ico/zoom-fit.png",
          "zoom-fit",
          false,
          undefined,
          () => ViewPortActions.setDefaultZoom()
        )}
        </div>
    </div>
  );
};

const mapDispatchToProps = {
  updateImageDragModeStatusAction: updateImageDragModeStatus,
  updateAiModeStatusAction: updateAiModeStatus,
  updateCrossHairVisibleStatusAction: updateCrossHairVisibleStatus,
  updateAiAssistModeAction: updateAiAssistMode,
  updateAiAssistStatusAction: updateAiAssistStatus,
  toggleAiAssistFormAction: toggleAiAssistForm,
  toggleAiAssistButtonsAction: toggleAiAssistButtons,
};


const mapStateToProps = (state: AppState) => ({
  activeContext: state.general.activeContext,
  imageDragMode: state.general.imageDragMode,
  aiMode:state.general.aiMode,
  aiAssist: state.general.aiAssist,
  crossHairVisible: state.general.crossHairVisible,
  activeLabelType: state.labels.activeLabelType,
  activeImageIndex: state.labels.activeImageIndex,
  imagesData: state.labels.imagesData,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditorTopNavigationBar);
